module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-leader"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "index-leader-inner"
  }, [_c('div', {
    staticClass: "img-block",
    style: ('background-image:url(' + _vm.article.poster.url + ')')
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.article.loading),
      expression: "article.loading"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personPager.loading),
      expression: "personPager.loading"
    }],
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-3x fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container leader-swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.personPager.persons), function(person) {
    return _c('div', {
      staticClass: "swiper-slide leader-swiper-slide"
    }, [_c('div', {
      staticClass: "avatar-name-block",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return person.click()
        }
      }
    }, [_c('div', [(person.image && person.image.url) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": person.image.url
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "person-name"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(person.name) + "\n\n\n\t\t\t\t\t\t")])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-title"
  }, [_c('i', {
    staticClass: "fa fa-mortar-board"
  }), _vm._v(" "), _c('span', [_vm._v("课程负责人")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("课程团队")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1eeacfd7"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/index/widget/IndexLeader.vue
// module id = 958
// module chunks = 1